var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSubscription = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 2.25A1.75 1.75 0 0 0 1.25 4v8c0 .966.784 1.75 1.75 1.75h4v-1.5H3a.25.25 0 0 1-.25-.25V6.04L8 7.79l5.25-1.75V8h1.5V4A1.75 1.75 0 0 0 13 2.25zm10.25 2.21V4a.25.25 0 0 0-.25-.25H3a.25.25 0 0 0-.25.25v.46L8 6.21zM10 10.25a.75.75 0 0 0 0 1.5h1.25V13a.75.75 0 0 0 1.5 0v-1.25H14a.75.75 0 0 0 0-1.5h-1.25V9a.75.75 0 0 0-1.5 0v1.25z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSubscription);
export default ForwardRef;